import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const baseBackgroundCircleProps = {
  r: 50,
  cx: 60,
  cy: 60,
  strokeWidth: 10,
};

const baseCircleProps = {
  r: 40,
  cx: 60,
  cy: 60,
  strokeWidth: 15,
};
const circumference = baseCircleProps.r * 2 * Math.PI;
const strokeDasharray = `${circumference} ${circumference}`;

class LoaderProgress extends React.PureComponent {
  static getStrokeDashoffset(percent) {
    return {
      strokeDashoffset: circumference - (percent / 100) * circumference,
    };
  }

  constructor(props) {
    super(props);

    this.state = LoaderProgress.getStrokeDashoffset(props.percentages);
  }

  componentDidUpdate(prevProps) {
    const { percentages } = this.props;

    if (prevProps.percentages === percentages) {
      return;
    }

    this.setProgress(percentages);
  }

  setProgress(percentages) {
    this.setState(LoaderProgress.getStrokeDashoffset(percentages >= 100 ? 100 : percentages));
  }

  render() {
    const { className, circleClassName, showBackground, showCircleShadow } = this.props;
    const { strokeDashoffset } = this.state;

    return (
      <svg className={classnames(className, 'new-loader--progress')} viewBox="0 0 120 120">
        {showBackground && (
          <circle {...baseBackgroundCircleProps} className={classnames(circleClassName, 'new-loader--progress-circle-background')} />
        )}
        {showCircleShadow && <circle {...baseCircleProps} className={classnames(circleClassName, 'new-loader--progress-circle-shadow')} />}
        <circle
          {...baseCircleProps}
          strokeDasharray={strokeDasharray}
          className={classnames(circleClassName, 'new-loader--progress-circle')}
          strokeDashoffset={strokeDashoffset}
        />
      </svg>
    );
  }
}

LoaderProgress.defaultProps = {
  showBackground: true,
  showCircleShadow: true,
};

LoaderProgress.propTypes = {
  className: PropTypes.string,
  percentages: PropTypes.number.isRequired,
  circleClassName: PropTypes.string,
  showBackground: PropTypes.bool,
  showCircleShadow: PropTypes.bool,
};

export default LoaderProgress;
